export function buildSerieFromCollection({data = [], xAxisKey, yAxisKey, sort = true, xAxisDate = true}) {
  let res = data.map(el => ([xAxisDate ? formatDate(el[xAxisKey]) : el[xAxisKey], el[yAxisKey]]));
  if (sort) {
    res = res.sort((a,b) => (a[xAxisKey] - b[xAxisKey]))
  }
  return res;
}

export function formatDate(date) {
  return date * 1000;
}
